module.exports = __webpack_public_path__ + "img/thumb-icon.cb8e5947.svg";